import { buildEventHandler } from '../AsyncActionsProvider/AsyncActionsProvider.events';
import { PromptMessage } from './PromptModals.interface';

export const { dispatch: prompt, subscribe } = buildEventHandler<PromptMessage, Promise<any>>();
